import { ChangeDetectorRef, Component, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { first } from 'rxjs/operators';
import { Jurisdiction, IJurisdiction } from '../../../foundation/models/enums/jurisdiction.enum';
import { BaseComponent } from '../../../shared/base-components/base.component';
import { RouteParameterType } from '../../../shared/enums/route-parameters.enum';
import { setServerDate } from '../../../shared/helpers/time-helpers.model';
import { SelectListItemModel } from '../../../shared/models/select-list-item.model';
import { NavigationService } from '../../../shared/services/navigation/navigation.service';
import { TransactionService } from '../../../titleregistration/services/transaction.service';
import { Brand, IBrand } from '../../models/enums/brand.enum';
import { VehicleService } from '../../services/vehicle.service';
import { VehicleBrandsModel } from './vehicle-brands.model';
// import { Date } from 'core-js';

@Component({
    selector: 'vehicle-brands',
    templateUrl: './vehicle-brands.html',
    inputs: ['vehicleId', 'businessTransactionId', 'vehicleTypeId', 'nmvtisBrands', 'vehicleBrands', 'newVehicleBrand', 'enableAddBrand'],
    // outputs: ['changed']
})
export class VehicleBrandsComponent extends BaseComponent {
    public lookUpsLoaded: boolean;
    public dataLoaded: boolean;
    public vehicleId: number;
    public vehicleTypeId: number;
    public businessTransactionId: number;
    public vehicleLookups: any;
    public brands: IBrand[];
    public filteredBrands: IBrand[];
    public jurisdictions: IJurisdiction[];
    public brand: Brand = new Brand();
    public vehicleBrands: VehicleBrandsModel[];
    public nmvtisBrands: VehicleBrandsModel[];
    public newVehicleBrand: VehicleBrandsModel;
    // public changed: EventEmitter<Object> = new EventEmitter();
    public showBrands: boolean;
    public jurisdiction: Jurisdiction = new Jurisdiction();
    public ifBrandsDeleted = false;
    public dbBrand: VehicleBrandsModel; // to keep track of autopopulate brand
    public enableAddBrand = true;

    constructor(
        public changeDetectionRef: ChangeDetectorRef,
        public _router: Router,
        private _route: ActivatedRoute,
        private _vehicleService: VehicleService,
        private transactionService: TransactionService,
        private navigationService: NavigationService
    ) {
        super();
        this.dataLoaded = false;
        this.lookUpsLoaded = false;
    }

    async ngOnInit() {
        // var t = this.nmvtisBrands;
        let brandsDb: VehicleBrandsModel[] = await this._vehicleService.getVehicleBrandsByVehicleId(this.vehicleId).pipe(first()).toPromise();
        if (brandsDb && brandsDb.length == 1) {
            this.dbBrand = brandsDb[0];
        }

        this.jurisdictions = this.jurisdiction.GetAll();
        let filteredBrandIds = [
            this.brand.Crushed.id,
            this.brand.Dismantled.id,
            this.brand.FloodDamage.id,
            this.brand.NonRepairable.id,
            this.brand.Reconstructed.id,
            this.brand.Refurbished.id,
            this.brand.RestoredSalvage.id,
            this.brand.Retrofit.id,
            this.brand.Salvage.id,
            this.brand.StateAssignedVIN.id,
            this.brand.Stolen.id
        ];
        this.brands = this.brand.GetAll();
        this.filteredBrands = this.brand.GetAll().filter(b => filteredBrandIds.indexOf(b.id) > -1);
        if (this.newVehicleBrand.brandID == 0) {
            // this.newVehicleBrand = new VehicleBrandsModel();
            this.newVehicleBrand.effectiveDate = new Date();
            this.newVehicleBrand.effectiveDateString = this.getCurrentDateToString();
            this.newVehicleBrand.id = -1;
            this.newVehicleBrand.brandID = 0;
            this.newVehicleBrand.jurisdictionID = 4;
            this.showBrands = false;
        } else {
            this.showBrands = true;
            this.newVehicleBrand.effectiveDateString = this.getEffectiveDateFormatted(this.newVehicleBrand);
        }
        if (!this.businessTransactionId) {
            if (this._route.snapshot.params[RouteParameterType.id]) {
                this.businessTransactionId = this._route.snapshot.params[RouteParameterType.id];
            }
        }
        this.dataLoaded = true;
    }

    isHomeJurisdiction() {
        return this.nmvtisBrands; // && this.nmvtisBrands.length == 1;
    }

    getEffectiveDateFormatted(brand: VehicleBrandsModel): string {
        return moment(brand.effectiveDate).format('L');
    }

    setEffectiveDateFormatted(brand: VehicleBrandsModel, val: Date) {
        var momentDate = setServerDate(val);
        if (momentDate != null && momentDate != undefined) {
            brand.effectiveDate = momentDate;
        }
    }

    inputEffectiveDateFormatted(brand: VehicleBrandsModel, val: Event) {
        var momentDate = setServerDate(val);
        if (momentDate != null && momentDate != undefined) {
            brand.effectiveDate = momentDate;
        }
    }

    public setEffectiveDate = (): void => {
        if (this.dbBrand && this.dbBrand.brandID == this.newVehicleBrand.brandID) {
            this.newVehicleBrand.effectiveDate = this.dbBrand.effectiveDate;
        } else {
            this.newVehicleBrand.effectiveDate = new Date();
        }
    };
    /**
    * Get the current date.
    */
    private getCurrentDateToString(): string {
        var currentDate: Date = new Date();
        var month: string = (currentDate.getMonth() + 1).toString();
        var day: string = currentDate.getDate().toString();
        var date = (month[1] ? month : '0' + month[0]) + '/' + (day[1] ? day : '0' + day[0]) + '/' + currentDate.getFullYear();
        return date;
    }

    async deleteExistingBrands() {
        this.vehicleBrands.length = 0;
    }

    async refreshBrands() {
        let brandsDb: VehicleBrandsModel[] = await this._vehicleService.getVehicleBrandsByVehicleId(this.vehicleId).pipe(first()).toPromise();
        if (brandsDb && brandsDb.length) {
            this.vehicleBrands.length = 0;
            for (const brand of brandsDb) {
                this.vehicleBrands.push(brand);
            }
        }
    }

    // can an existing brand be deleted
    public canDelete() {
        return this.vehicleBrands && this.vehicleBrands.length && !this.ifBrandsDeleted;
    }

    private isnmvtisJurisdiction(jurisdictionId: number): boolean {
        if (!jurisdictionId) {
            return false;
        }
        let jurisdiction = this.jurisdiction.FromId(jurisdictionId);
        return jurisdiction && jurisdiction.isNMVTISParticipation;
    }

    public hideBrand() {
        this.newVehicleBrand.brandID = 0;
        this.showBrands = false;
    }
    public showBrand() {
        this.newVehicleBrand.id = -1;
        this.newVehicleBrand.jurisdictionID = 4;
        this.newVehicleBrand.effectiveDateString = this.getCurrentDateToString();
        this.showBrands = true;
    }
}
